import React, { useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Timer, ArrowBack, Delete, Business, Save } from "@material-ui/icons";
import StorageIcon from "@mui/icons-material/Storage";
import { FormikProvider, useFormik } from "formik";
import "react-tabs/style/react-tabs.css";
import styled, { keyframes } from "styled-components";
import * as yup from "yup";
import fetchClient from "../../api/fetchClient";
import Tabs from "../../components/ariba/Tabs";
import message from "../../helper/message";
import LogsMetadataModal from "../../components/concur/LogsMetadataModal";
import axios from "axios";

const metadataPath = process.env.REACT_APP_METADATA_PATH;

const validationSchema = yup.object({
    grupoId: yup.string().required("Grupo é obrigatório"),
    cnpj: yup
        .string()
        .required("CNPJ é obrigatório")
        .matches(/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/, "CNPJ formato inválido"),
    name: yup.string("Informe o nome da empresa").required("Nome é obrigatório"),
    description: yup
        .string("Informe a descrição da empresa")
        .required("Descrição é obrigatório"),
    login: yup.string("Informe o login do sap").required("Login é obrigatório"),
    password: yup.string("Informe a senha do sap").required("Password é obrigatório"),
    database: yup.string("Informe o banco de dados").required("Banco de dados é obrigatório"),
    url: yup
        .string("Informe a url da service layer")
        .required("Url da service layer é obrigatório"),
});

function AplicacaoAribaPage(props) {
    const { data, isViewing } = props;

    const [empresa, setEmpresa] = useState(data);
    const [connected, setConnected] = useState(data.connected);
    const [connectedHana, setConnectedHana] = useState(data.connectedHana);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingToken, setIsLoadingToken] = useState(false);
    const [metadataCreationId, setMetadataCreationId] = useState(null);
    const [loadingMetadataCreation, setLoadingMetadataCreation] = useState(false);

    const save = async (empresa) => {
        console.log("Iniciando salvar:", empresa);
        await fetchClient.post("/ariba/company", {
            ...empresa,
            connected,
        });
    };

    const onRetrieveLogs = async () => {
        try {
            const { data } = await axios.get(
                `${metadataPath}/metadata/${metadataCreationId}?type=ariba`
            );
            return data;
        } catch (error) {
            message.error(error.message);
        }
    };

    // ===== Helpers =====
    const touchAllAndReport = async () => {
        const errs = await formik.validateForm();
        if (Object.keys(errs).length) {
            formik.setTouched(
                Object.keys(validationSchema.fields).reduce(
                    (acc, k) => ({ ...acc, [k]: true }),
                    {}
                ),
                true
            );
            message.error("Corrija os campos destacados antes de continuar.");
            return false;
        }
        return true;
    };

    const confirmDialog = async (texto) => {
        return window.confirm(texto);
    };


    // ===== Ações =====
    const onSave = async () => {
        try {
            const ok = await touchAllAndReport();
            if (!ok) return;
            const body = {
                id: formik.values.id,
                cnpj: formik.values.cnpj,
                grupoId: formik.values.grupoId,
                name: formik.values.name,
                description: formik.values.description,
                login: formik.values.login,
                password: formik.values.password,
                database: formik.values.database,
                urlHanaSql: formik.values.urlHanaSql,
                hPassword: formik.values.hPassword,
                hUserName: formik.values.hUserName,
                url: formik.values.url,
                enabled: !!formik.values.enabled,
                metadata: formik.values.metadata || false,
                rate: formik.values.rate || 30,
                master: formik.values.master || false,
                ariba_secret: formik.values.ariba_secret,
                ariba_realm_sourcing: formik.values.ariba_realm_sourcing,
                ariba_realm_buyer: formik.values.ariba_realm_buyer,
                company_code: formik.values.company_code,
                token: formik.values.token,
                connectedHana: connectedHana,
                identity: formik.values.identity,
                systemId: formik.values.systemId,
                series: formik.values.series,

                // ====== CAMPOS DA NOVA ABA (existentes) ======
                identityFrom: formik.values.identityFrom,
                identityTo: formik.values.identityTo,
                identitySender: formik.values.identitySender,
                sharedSecretNetwork: formik.values.sharedSecretNetwork,
                email: formik.values.email,
                catalogName: formik.values.catalogName,
                supplierIdDomain: formik.values.supplierIdDomain,
                operation: formik.values.operation,
                loadMode: formik.values.loadMode,
                webhookBasicPass: formik.values.webhookBasicPass,
                webhookBasicUser: formik.values.webhookBasicUser,
                urlResponseCustomer: formik.values.urlResponseCustomer,
                urlResponseBuyer: formik.values.urlResponseBuyer,
                urlResponseSourcing: formik.values.urlResponseSourcing,
                basicPassBuyer: formik.values.basicPassBuyer,
                basicUserBuyer: formik.values.basicUserBuyer,
                passwordCatalog: formik.values.passwordCatalog,
                userNameCatalog: formik.values.userNameCatalog,

                // ====== NOVOS (SOAP Parameters + Attachment + Endpoint/Auth) ======
                realm: formik.values.realm,                       // NEW
                Solution: formik.values.Solution,                 // NEW
                Variant: formik.values.Variant,                   // NEW
                Partition: formik.values.Partition,               // NEW
                SubscriptionName: formik.values.SubscriptionName, // NEW
                MultiSupplierCIF: formik.values.MultiSupplierCIF, // NEW
                ByPassApproval: formik.values.ByPassApproval,     // NEW
                autoPublish: formik.values.autoPublish,           // NEW
                ANSupplierID: formik.values.ANSupplierID,         // NEW
                contentID: formik.values.contentID,               // NEW
                languageDefault: formik.values.languageDefault,   // NEW
                soapUrl: formik.values.soapUrl                    // NEW

            };

            await save(body);
            isViewing(false);
            message.sucess("Salvo com sucesso!");
        } catch (error) {
            console.error("Erro ao salvar:", error);
            message.error(error.response?.data?.message || "Erro ao salvar.");
        }
    };

    const onDelete = async (id) => {
        try {
            if (!id) {
                return message.error("Registro sem ID. Salve primeiro para poder excluir.");
            }
            const confirmar = await confirmDialog("Deseja realmente excluir este grupo?");
            if (!confirmar) return;

            await fetchClient.delete(`/ariba/${id}`);
            isViewing(false);
            message.sucess("Registro deletado com sucesso");
        } catch (error) {
            console.error("Erro ao deletar:", error);
            message.error(error.response?.data?.message || "Erro ao deletar.");
        }
    };

    const onInitializeMetadataCreation = async (id) => {
        try {
            // precisa de um registro salvo para vincular a company
            if (!id) {
                const ok = await touchAllAndReport();
                if (!ok) return;
                return message.error("Salve a empresa antes de criar a metadata.");
            }

            if (metadataCreationId) {
                const prosseguir = await confirmDialog(
                    "Já existe uma criação de metadata em andamento para este registro. Deseja iniciar outra?"
                );
                if (!prosseguir) return;
            }

            setLoadingMetadataCreation(true);
            const { data } = await axios.post(`${metadataPath}/metadata`, {
                company: id,
                type: "ariba",
            });
            setMetadataCreationId(data.uuid);
            message.sucess("Criação de metadata iniciada.");
        } catch (error) {
            message.error(error.message);
        } finally {
            setLoadingMetadataCreation(false);
        }
    };

    const onTestConnectSL = async () => {
        try {
            setIsLoading(true);
            const empresa = { id: formik.values.id };
            await fetchClient.post("ariba/testConnectionSap", empresa);
            message.sucess("Conectado com sucesso");
            formik.setFieldValue("connected", true);
            setConnected(true);
            setEmpresa((v) => ({ ...v, connected: true }));
            setIsLoading(false);
        } catch (error) {
            formik.setFieldValue("connected", false);
            setIsLoading(false);
            setConnected(false);
            setEmpresa((v) => ({ ...v, connected: false }));
            console.log(error);
            message.error(error.response?.data?.message || "Erro ao conectar.");
        }
    };

    const onTestConnectHana = async () => {
        try {

            setIsLoading(true);
            const empresa = { id: formik.values.id };
            await fetchClient.post("ariba/connectHanaSQL", empresa);
            message.sucess("Conectado com sucesso");
            formik.setFieldValue("connectedHana", true);
            setConnectedHana(true);
            setEmpresa((v) => ({ ...v, connectedHana: true }));
            setIsLoading(false);
        } catch (error) {
            formik.setFieldValue("connectedHana", false);
            setIsLoading(false);
            setConnectedHana(false);
            setEmpresa((v) => ({ ...v, connectedHana: false }));
            console.log(error);
            message.error(error.response?.data?.message || "Erro ao conectar.");
        }
    };

    const onGenerateToken = async () => {
        try {
            setIsLoadingToken(true);

            if (formik.values.token) {
                const confirma = await confirmDialog(
                    "Já existe um token gerado para esta empresa. Deseja gerar um novo? O anterior será substituído."
                );
                if (!confirma) {
                    setIsLoadingToken(false);
                    return;
                }
            }

            const empresa = { id: formik.values.id };
            if (!empresa.id) {
                setIsLoadingToken(false);
                return message.error("Salve a empresa antes de gerar o token.");
            }

            const { data } = await fetchClient.post("ariba/aplicacao/token", empresa);

            message.sucess("Token gerado com sucesso !");
            const { message: response } = data;
            formik.setFieldValue("token", response.token);

            setIsLoadingToken(false);
        } catch (error) {
            console.log(error);
            setIsLoadingToken(false);
            message.error(error.response?.data?.message || "Erro ao gerar token.");
        }
    };

    // ===== Defaults & Formik =====
    const defaultValues = {
        id: empresa.id || "",
        cnpj: empresa.cnpj || "",
        name: empresa.name || "",
        grupoId: empresa.grupoId || "",
        description: empresa.description || "",
        login: empresa.login || "",
        password: empresa.password || "",
        database: empresa.database || "",
        urlHanaSql: empresa.urlHanaSql || "",
        hPassword: empresa.hPassword || "",
        hUserName: empresa.hUserName || "",
        url: empresa.url || "",
        enabled: empresa.enabled || false,
        metadata: empresa.metadata || false,
        rate: empresa.rate || 30,
        master: empresa.master || false,
        ariba_secret: empresa.ariba_secret || "",
        ariba_realm_buyer: empresa.ariba_realm_buyer || "",
        ariba_realm_sourcing: empresa.ariba_realm_sourcing || "",
        token: empresa.token || "",
        company_code: empresa.company_code || "",
        identity: empresa.identity || "",
        systemId: empresa.systemId || "",
        series: empresa.series || "",

        // ====== CAMPOS DA NOVA ABA (existentes) ======
        identityFrom: empresa.identityFrom || "",
        identityTo: empresa.identityTo || "",
        identitySender: empresa.identitySender || "",
        sharedSecretNetwork: empresa.sharedSecretNetwork || "",
        email: empresa.email || "",
        catalogName: empresa.catalogName || "",
        supplierIdDomain: empresa.supplierIdDomain || "",
        operation: empresa.operation || "update",
        loadMode: empresa.loadMode || "I",
        webhookBasicPass: empresa.webhookBasicPass || "",
        webhookBasicUser: empresa.webhookBasicUser || "",
        urlResponseCustomer: empresa.urlResponseCustomer || "",
        urlResponseBuyer: empresa.urlResponseBuyer || "",
        urlResponseSourcing: empresa.urlResponseSourcing || "",
        basicPassBuyer: empresa.basicPassBuyer || "",
        basicUserBuyer: empresa.basicUserBuyer || "",
        passwordCatalog: empresa.passwordCatalog || "",
        userNameCatalog: empresa.userNameCatalog || "",

        // ====== NOVOS (SOAP Parameters + Attachment + Endpoint/Auth) ======
        realm: empresa.realm || "",                         // NEW
        Solution: empresa.Solution || "BuyerCatalog",       // NEW
        Variant: empresa.Variant || "",                     // NEW
        Partition: empresa.Partition || "",                 // NEW
        SubscriptionName: empresa.SubscriptionName || "",   // NEW
        MultiSupplierCIF: empresa.MultiSupplierCIF ?? true, // NEW (boolean)
        ByPassApproval: empresa.ByPassApproval ?? true,     // NEW (boolean)
        autoPublish: empresa.autoPublish ?? true,           // NEW (boolean)
        ANSupplierID: empresa.ANSupplierID || (empresa.identityFrom || ""), // NEW
        contentID: empresa.contentID || "",                 // NEW (AttachmentFolder contentID)
        languageDefault: empresa.languageDefault || "ptBR", // NEW (usado no CIF)
        soapUrl: empresa.soapUrl || ""                      // NEW (endpoint SOAP)
    };



    const formik = useFormik({
        initialValues: defaultValues,
        validationSchema: validationSchema,
        enableReinitialize: true,
        validateOnMount: true,
        onSubmit: async (values) => {
            console.log("Submetendo valores:", values);
            await onSave(values);
        },
    });

    const { touched, values, errors, handleChange, isSubmitting, isValid, dirty } = formik;

    return (
        <FormikProvider value={formik}>
            <Container>
                {metadataCreationId && (
                    <LogsMetadataModal
                        show={(bool) => bool === false && setMetadataCreationId(null)}
                        onRetrieveLogs={onRetrieveLogs}
                    />
                )}
                <PageContent>
                    <ModernHeader>
                        <HeaderLeft>
                            <BackButton onClick={() => isViewing(false)}>
                                <ArrowBack />
                            </BackButton>
                            <HeaderContent>
                                <PageTitle>
                                    <Business style={{ marginRight: '12px', fontSize: '32px' }} />
                                    {empresa.newBusiness ? 'Nova Aplicacao Ariba' : 'Editar Aplicacao'}
                                </PageTitle>
                                <PageSubtitle>
                                    {empresa.newBusiness ? 'Cadastre uma nova aplicacao Ariba no sistema' : 'Gerencie as informacoes da aplicacao'}
                                </PageSubtitle>
                            </HeaderContent>
                        </HeaderLeft>
                    </ModernHeader>

                    <ActionsCard>
                        <ActionsGrid>
                            <ActionButton
                                variant="danger"
                                disabled={!empresa.id || isLoading || isLoadingToken || loadingMetadataCreation}
                                onClick={async () => await onDelete(empresa.id)}
                            >
                                <Delete style={{ marginRight: '8px', fontSize: '20px' }} />
                                Excluir
                            </ActionButton>

                            <ActionButton
                                variant="primary"
                                onClick={onSave}
                                disabled={isSubmitting || (isLoading && !values.id) || (!dirty && !values.id)}
                            >
                                {isSubmitting || (isLoading && !values.id) ? (
                                    <CircularProgress size={20} style={{ color: 'white' }} />
                                ) : (
                                    <>
                                        <Save style={{ marginRight: '8px', fontSize: '20px' }} />
                                        Salvar
                                    </>
                                )}
                            </ActionButton>

                            <ActionButton
                                variant="primary"
                                onClick={async () => await onInitializeMetadataCreation(empresa.id)}
                                disabled={loadingMetadataCreation || isSubmitting}
                            >
                                {loadingMetadataCreation ? (
                                    <CircularProgress size={20} style={{ color: 'white' }} />
                                ) : (
                                    <>
                                        <StorageIcon style={{ marginRight: '8px', fontSize: '20px' }} />
                                        Criar Metadata
                                    </>
                                )}
                            </ActionButton>

                            <ActionButton
                                variant="warning"
                                onClick={onGenerateToken}
                                disabled={isLoadingToken || isSubmitting}
                            >
                                {isLoadingToken ? (
                                    <CircularProgress size={20} style={{ color: 'white' }} />
                                ) : (
                                    <>
                                        <Timer style={{ marginRight: '8px', fontSize: '20px' }} />
                                        Gerar Token
                                    </>
                                )}
                            </ActionButton>
                        </ActionsGrid>
                    </ActionsCard>

                    <FormCard>
                        <Form autoComplete="off">
                            <Tabs
                                values={values}
                                touched={touched}
                                errors={errors}
                                handleChange={handleChange}
                                onTestConnect={onTestConnectSL}
                                onTestConnectHana={onTestConnectHana}
                                connected={connected}
                                connectedHana={connectedHana}
                                isLoading={isLoading}
                                isLoadingHana={isLoading}
                            />
                        </Form>
                    </FormCard>
                </PageContent>
            </Container>
        </FormikProvider>
    );
}

export default AplicacaoAribaPage;

// ===== STYLED COMPONENTS =====

// Animacoes
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 65px);
  background-color: #f3f4f6;
  font-family: 'Mulish', sans-serif;
  box-sizing: border-box;
  overflow-x: hidden;
`;

const PageContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
  padding: 3rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const ModernHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  animation: ${fadeIn} 0.6s ease;
  margin-bottom: 2.5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

const HeaderContent = styled.div`
  flex: 1;
`;

const PageTitle = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 6px 0;
  display: flex;
  align-items: center;
  font-family: 'Mulish', sans-serif;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const PageSubtitle = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
  font-family: 'Mulish', sans-serif;
`;

const BackButton = styled.button`
  background: rgba(230, 126, 34, 0.1);
  border: none;
  border-radius: 12px;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #e67e22;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover {
    background: rgba(230, 126, 34, 0.2);
    transform: translateX(-4px);
  }

  &:active {
    transform: translateX(0);
  }
`;

const ActionsCard = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: ${fadeIn} 0.5s ease 0.1s both;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;
`;

const ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ActionButton = styled.button`
  background: ${props => {
    if (props.variant === 'danger') return 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)';
    if (props.variant === 'success') return 'linear-gradient(135deg, #27ae60 0%, #229954 100%)';
    if (props.variant === 'warning') return 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)';
    return 'linear-gradient(135deg, #e67e22 0%, #f39c12 100%)';
  }};
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  font-family: 'Mulish', sans-serif;
  box-shadow: 0 2px 8px ${props => {
    if (props.variant === 'danger') return 'rgba(231, 76, 60, 0.3)';
    if (props.variant === 'success') return 'rgba(39, 174, 96, 0.3)';
    if (props.variant === 'warning') return 'rgba(243, 156, 18, 0.3)';
    return 'rgba(230, 126, 34, 0.3)';
  }};

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px ${props => {
      if (props.variant === 'danger') return 'rgba(231, 76, 60, 0.4)';
      if (props.variant === 'success') return 'rgba(39, 174, 96, 0.4)';
      if (props.variant === 'warning') return 'rgba(243, 156, 18, 0.4)';
      return 'rgba(230, 126, 34, 0.4)';
    }};
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background: #bdbdbd;
    cursor: not-allowed;
    box-shadow: none;
    opacity: 0.6;
  }
`;

const FormCard = styled.div`
  background: white;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  animation: ${fadeIn} 0.5s ease 0.2s both;
  transition: all 0.3s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d0d0d0;
  }
`;

const Form = styled.form`
  width: 100%;
`;
